import actions from '../../actionTypes';

export default (site, orgId) => {
  return {
    type: actions.EDIT_SITE_LABELS,
    site,
    orgId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/editSiteLabels.js